import Config from "../../config/config";
import { axiosFunc, isEmpty } from "../commonFunction";

const errMsg = (msg) => {
  return { status: false, message: msg.toString() };
};
export const Signon = async (data) => {
  try {
    let respData = await axiosFunc(
      {
        method: "GET",
        url: `${Config.v1Url}user/getuser`,
      },
      data.data
    );
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ Signon ~ err:", err);
    return errMsg(err);
  }
};

export const getCategory = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "GET",
      url: `${Config.v1Url}user/getcategory`,
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ getCategory ~ err:", err);
    return errMsg(err);
  }
};

export const getNetwork = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "GET",
      url: `${Config.v1Url}user/getnetwork`,
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ getNetwork ~ err:", err);
    return errMsg(err);
  }
};
export const getCoins = async (data) => {
  console.log("🚀 ~ getCoins ~ data:", data);
  try {
    let respData = await axiosFunc({
      method: "GET",
      url: `${Config.v1Url}user/getalltokens`,
      params: data,
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ getCoins ~ err:", err);
    return errMsg(err);
  }
};

export const getCoinDetail = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "GET",
      url: `${Config.v1Url}user/gettokendetail`,
      params: data,
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ getCoinDetail ~ err:", err);
    return errMsg(err);
  }
};

export const getMarketpairlist = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "GET",
      url: `${Config.v1Url}user/getcryptomarketpair`,
      params: data,
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ getMarketpairlist ~ err:", err);
    return errMsg(err);
  }
};

export const getCandlestick = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "GET",
      url: `${Config.v1Url}user/getcandlestick`,
      params: data,
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ getCandlestick ~ err:", err);
    return errMsg(err);
  }
};

export const getExchanges = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "GET",
      url: `${Config.v1Url}user/getexchanges`,
      params: data,
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ getExchanges ~ err:", err);
    return errMsg(err);
  }
};

export const getExchageData = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "GET",
      url: `${Config.v1Url}user/getexchangedetail`,
      params: data,
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ getExchanges ~ err:", err);
    return errMsg(err);
  }
};

export const getTickerlist = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "GET",
      url: `${Config.v1Url}user/gettickers`,
      params: data,
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ getTickerlist ~ err:", err);
    return errMsg(err);
  }
};

export const subscribe = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "POST",
      url: `${Config.v1Url}user/subscribe`,
      data: data,
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ subscribe ~ err:", err);
    return errMsg(err);
  }
};

export const getSocialLinkList = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "GET",
      url: `${Config.v1Url}user/getsociallink`,
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ getSocialLinkList ~ err:", err);
    return errMsg(err);
  }
};

export const getHeaderData = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "GET",
      url: `${Config.v1Url}user/getheaderdata`,
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ getHeaderData ~ err:", err);
    return errMsg(err);
  }
};

export const addWistList = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "POST",
      url: `${Config.v1Url}user/addwish`,
      data: data,
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ addWistList ~ err:", err);
    return errMsg(err);
  }
};

export const getWishlist = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "GET",
      url: `${Config.v1Url}user/getwishlist`,
      params: data,
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ getWishlist ~ err:", err);
    return errMsg(err);
  }
};

export const removeWishList = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "POST",
      url: `${Config.v1Url}user/removewishlist`,
      data: data,
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ removeWishList ~ err:", err);
    return errMsg(err);
  }
};

export const getCmsData = async (data) => {
  try {
    let respData = await axiosFunc({
      method: "GET",
      url: `${Config.v1Url}user/getcms`,
      ...(isEmpty(data) ? {} : { params: data }),
    });
    return respData.data;
  } catch (err) {
    console.log("🚀 ~ getHeaderData ~ err:", err);
    return errMsg(err);
  }
};
